import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type AstState = {}

const AstInitialState: AstState = {}

export namespace AstNS {
	export type SendProcurementPlan = PayloadAction
}

export const astSlice = createSlice({
	name: 'ast',
	initialState: AstInitialState,
	reducers: {
		sendProcurementPlan: (state, action: AstNS.SendProcurementPlan) => {},
	},
})
